import zh_CN from "../../../../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/zh_CN.js";
const fileManagerRestrictionLocale = {
  maxFileSize: "最大文件大小",
  maxFiles: "最大文件数量",
  maxTotalSize: "最大总大小",
  allowedTypes: "允许的文件类型",
  description: "拖拽文件到此处或点击上传",
  or: "或",
  buttonText: "选择文件",
  emptyText: "暂无文件",
  statusText: {
    init: "初始化",
    uploading: "上传中",
    success: "成功",
    failed: "失败",
    cancelled: "取消",
    paused: "暂停",
    saved: "已保存"
  },
  uppyLocale: zh_CN
};
export {
  fileManagerRestrictionLocale
};
//# sourceMappingURL=zh_CN.js.map
